module.exports = __webpack_public_path__ + "img/dstv-login-4.d03b4ca8.jpg";